"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssStyle = cssStyle;
exports.makeUpHtml = makeUpHtml;
exports.vueScript = vueScript;
exports.vueTemplate = vueTemplate;
var _utils = _interopRequireDefault(require("./utils"));
var _main = _interopRequireDefault(require("./main"));
var _build = _interopRequireDefault(require("./build"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* eslint-disable max-len */

var confGlobal;
function vueTemplate(str) {
  return "\n\t\t<div>\n\t\t\t".concat(str, "\n\t\t\t<yl-lc-imageViewer v-if=\"imageViewVisible\" :url-list=\"imageViewDataList\"></yl-lc-imageViewer>\n\t\t</div>\n\t");
}
function vueScript(str) {
  return "<script>\n\t\t".concat(str, "\n\t</script>");
}
function cssStyle(cssStr) {
  return "<style>\n\t\t".concat(cssStr, "\n\t</style>");
}

// span不为24的用el-col包裹
function colWrapper(scheme, str) {
  if (scheme.__config__.span !== undefined && scheme.__config__.span !== 24) {
    return "<el-col :span=\"".concat(scheme.__config__.span, "\">").concat(str, "</el-col>");
  } else {
    return str;
  }
}
var layouts = {
  colFormItem: function colFormItem(scheme, elForm) {
    var config = scheme.__config__;
    var labelWidth = '';
    // let label = `label="${tools.createMatchField(scheme.dataSource.body)}"`
    if (config.showLabel === false) {
      labelWidth = 'label-width="0"';
    }
    var labelData = scheme.dataSource;
    var varChar = labelData.body.match(/{{(?!scope\.)(.*?)}}/);
    var matchStr = varChar ? varChar.input.replace(varChar[0], _main["default"].createMatchField(varChar[0])) : labelData.body;
    var tagDom = tags[config.tag] ? tags[config.tag](scheme, elForm) : null;
    var formLabel = labelData.body.includes("scope") ? matchStr : labelData.isHtml ? _main["default"].createMatchTextHtml(labelData.body) : _main["default"].createMatchField(labelData.body);
    var displayBody = config.tag === 'yl-lc-button' ? scheme.isShow.body && el.isShow.body.includes('scope') ? _main["default"].replaceChars(scheme.isShow.body) : "source.".concat(_main["default"].replaceChars(scheme.isShow.body)) : config.isShow.body && config.isShow.body.includes('scope') ? _main["default"].replaceChars(config.isShow.body) : "source.".concat(_main["default"].replaceChars(config.isShow.body));
    var targetDisplay = config.tag === 'yl-lc-button' ? "".concat(scheme.isShow.isAction ? scheme.isShow.status : displayBody) : "".concat(config.isShow.isAction ? config.isShow.status : displayBody);
    var str = "<el-form-item ".concat(labelWidth, " prop='").concat(config.target, "' v-if=\"").concat(targetDisplay, "\">\n                    <template slot='label'>\n                        ").concat(config.showLabel ? formLabel : '', "\n                    </template>\n                    ").concat(tagDom, "\n                </el-form-item>");
    str = colWrapper(scheme, str);
    return str;
  },
  rowItem: function rowItem(scheme, elForm) {
    var config = scheme.__config__;
    var gutter = config.gutter ? ":gutter=\"".concat(config.gutter, "\"") : '';
    //const align = config.align ? `align="${config.align}"` : ''
    var justify = config.justify ? "text-".concat(config.justify) : '';
    var children = config.children.map(function (el) {
      return layouts[el.__config__.layout](el, elForm);
    });
    var str = "<el-row ".concat(gutter, " class='").concat(justify, "'>\n\t\t\t").concat(children.join('\n'), "\n\t\t</el-row>");
    str = colWrapper(scheme, str);
    return str;
  },
  rowComponent: function rowComponent(scheme) {
    var config = scheme.__config__;
    var tagDom = tags[config.tag] ? tags[config.tag](scheme, config.children) : null;
    return colWrapper(scheme, tagDom);
  },
  rowContent: function rowContent(scheme) {
    return this.rowComponent(scheme);
  }
};
var tags = {
  'yl-lc-title': function ylLcTitle(el) {
    var goback = "";
    var data = _utils["default"].buildYlTitle(el);
    if (!data.disabledBack) {
      if (el.__config__.custReturn.body) {
        goback = ":custReturn=".concat(_main["default"].replaceObjectChars(el.__config__.custReturn.body));
      }
      if (el.redirect) {
        goback = "redirect=".concat(el.redirect);
      }
    }
    return "<".concat(data.tag, " :title='").concat(data.title, ".main' ref='").concat(data.ref, "' :subTitle='").concat(data.title, ".sub' :disabledBack='").concat(data.disabledBack, "' ").concat(goback, " ").concat(data.style, "></").concat(data.tag, ">");
  },
  'yl-lc-search': function ylLcSearch(el) {
    var data = _utils["default"].buildYlSearchForm(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' :searchParmas=\"").concat(data.vmodel, "\" ").concat(data.dynamic, " ").concat(data.style, "></").concat(data.tag, ">");
  },
  'yl-lc-card': function ylLcCard(el, children) {
    var data = _utils["default"].buildYlCard(el, layouts, children);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.dynamic, " ").concat(data.style, ">").concat(data.child, "</").concat(data.tag, ">");
  },
  'yl-lc-table': function ylLcTable(el) {
    var data = _utils["default"].buildYlTable(el, layouts, el.__slot__.expand.list);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' :data=\"").concat(data.data, "\" ").concat(data.dynamic, " ").concat(data.style, ">\n\t\t\t<div slot=\"expand\">").concat(data.child, "</div>\n\t\t</").concat(data.tag, ">");
  },
  'yl-lc-page': function ylLcPage(el) {
    var data = _utils["default"].buildYlPage(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' :hidePage=\"").concat(data.hidePage, "\" :hideTotal=\"").concat(data.hideTotal, "\" ").concat(data.dynamic, " ").concat(data.style, "></").concat(data.tag, ">");
  },
  'el-tabs': function elTabs(el) {
    var data = _utils["default"].buildElTabs(el, layouts);
    return "<".concat(data.tag, " ").concat(data.vmodel, " ref='").concat(data.ref, "' type='").concat(data.type, "' ").concat(data.dynamic, " ").concat(data.style, ">").concat(data.child, "</").concat(data.tag, ">");
  },
  'el-collapse': function elCollapse(el) {
    var data = _utils["default"].buildElCollapse(el, layouts);
    return "<".concat(data.tag, " ").concat(data.vmodel, " ref='").concat(data.ref, "' ").concat(data.dynamic, " ").concat(data.style, ">").concat(data.child, "</").concat(data.tag, ">");
  },
  'yl-lc-dialog': function ylLcDialog(el) {
    var data = _utils["default"].buildYlDialog(el, layouts, el.__slot__.expand.list);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' :attributes='").concat(JSON.stringify(el.attributes), "' ").concat(data.dynamic, " ").concat(data.style, ">").concat(data.child, "</").concat(data.tag, ">");
  },
  'yl-lc-array-object': function ylLcArrayObject(el) {
    var data = _utils["default"].buildYlArrayObject(el, layouts, el.__config__.children[0]);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' align='").concat(el.align, "' :button='").concat(el.button, "' :group='source.").concat(_main["default"].replaceChars(el.__config__.body), "' ").concat(data.style, ">\n\t\t\t<template slot-scope=\"scope\">\n                ").concat(data.child.join('\n'), "\n\t\t\t</template>\n\t\t</").concat(data.tag, ">");
  },
  'yl-lc-form': function ylLcForm(el) {
    var data = _utils["default"].buildYlForm(el, tags);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' rowClass='").concat(data.rowClass, "' :isShowButton='").concat(data.isShowButton, "' :isShowCard='").concat(data.isShowCard, "' :isSingleFormCenter='").concat(data.isSingleFormCenter, "' title='").concat(data.title, "' :searchParmas=\"").concat(data.searchParmas, "\" :formButton=\"").concat(data.formButton, "\">").concat(data.button, "</").concat(data.tag, ">");
  },
  "yl-lc-button": function ylLcButton(el) {
    var data = _utils["default"].buildYlButton(el, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.scope, " ").concat(data.style, " v-if=\"").concat(data.display, "\" :disabled='").concat(data.disabled, "' ").concat(data.dynamic, " ").concat(data.vmodelDataSource, "></").concat(data.tag, ">");
  },
  "el-image": function elImage(el) {
    var data = _utils["default"].buildElImage(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.src, " ").concat(data.style, "/>");
  },
  "yl-lc-formReadOnly": function ylLcFormReadOnly(el) {
    var data = _utils["default"].buildYlFormReadOnly(el, tags);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' formTitle='").concat(data.formTitle, "' title='").concat(data.title, "' :params='").concat(data.vmodel, "'></").concat(data.tag, ">");
  },
  "yl-lc-text": function ylLcText(el) {
    var data = _utils["default"].buildDiv(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.scope, " ").concat(data.style, " ").concat(data.vmodelDataSource, "></").concat(data.tag, ">");
  },
  "el-link": function elLink(el) {
    var data = _utils["default"].buildElLink(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.style, " href='").concat(data.href, "' type=\"").concat(data.type, "\" target=\"").concat(data.target, "\" icon=\"").concat(data.icon, "\" :disabled=\"").concat(data.disabled, "\">").concat(data.defaultValue, "</").concat(data.tag, ">");
  },
  'el-steps': function elSteps(el) {
    var data = _utils["default"].buildElTeps(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' active='").concat(data.active, "' class='el-steps el-steps--horizontal' direction='").concat(data.direction, "' simple=\"").concat(data.simple, "\" space=\"").concat(data.space, "\" align-center=\"").concat(data['align-center'], "\" finish-status=\"").concat(data['finish-status'], "\" process-status='").concat(data['process-status'], "'>").concat(data.children, "</").concat(data.tag, ">");
  },
  'el-form': function elForm(el, children) {
    var data = _utils["default"].buildElForm(el, layouts, children);
    return "<".concat(data.tag, " :model='").concat(data.vmodel, "' ref='").concat(data.ref, "' ").concat(data.dynamic, ">").concat(data.child, "</").concat(data.tag, ">");
  },
  'el-input': function elInput(el, elForm) {
    var data = _utils["default"].buildElInput(el, elForm, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " :required='").concat(data.required, "' :readonly='").concat(data.readonly, "' placeholder='").concat(data.placeholder, "' type='").concat(data.type, "' prefix-icon=\"").concat(data['prefix-icon'], "\" suffix-icon=\"").concat(data['suffix-icon'], "\" :show-word-limit=\"").concat(data['show-word-limit'], "\" maxlength=\"").concat(data.maxlength, "\" :disabled='").concat(data.disabled, "' :clearable='").concat(data.clearable, "'></").concat(data.tag, ">");
  },
  'el-select': function elSelect(el, elForm) {
    var data = _utils["default"].buildElSelect(el, elForm, confGlobal);
    var child = _utils["default"].buildElSelectChild(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " :multiple='").concat(data.multiple, "' :required='").concat(data.required, "' placeholder='").concat(data.placeholder, "' :disabled='").concat(data.disabled, "' :clearable='").concat(data.clearable, "' style='max-width:480px'>\n            ").concat(child, "\n        </").concat(data.tag, ">");
  },
  'el-cascader': function elCascader(el, elForm) {
    var data = _utils["default"].buildElCascader(el, elForm, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " :options='").concat(data.vmodel, "' :show-all-levels='").concat(data['show-all-levels'], "' :filterable='").concat(data.filterable, "' separator='").concat(data.separator, "' :clearable='").concat(data.clearable, "' :collapse-tags='").concat(data['collapse-tags'], "' :disabled='").concat(data.disabled, "'></").concat(data.tag, ">");
  },
  'el-input-number': function elInputNumber(el, elForm) {
    var data = _utils["default"].buildElInputNumber(el, elForm, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " ").concat(data.min, " ").concat(data.max, " ").concat(data.step, " ").concat(data['step-strictly'], " :disabled='").concat(data.disabled, "' ").concat(data['controls-position'], " ").concat(data.precision, "></").concat(data.tag, ">");
  },
  'el-radio-group': function elRadioGroup(el, elForm) {
    var data = _utils["default"].buildElRadioGroup(el, elForm, confGlobal);
    var child = _utils["default"].buildElRadioGroupChild(el);
    if (child) child = "\n".concat(child, "\n"); // 换行
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " ").concat(data.size, " ").concat(data.border, " :disabled='").concat(data.disabled, "'>").concat(child, "</").concat(data.tag, ">");
  },
  'el-checkbox-group': function elCheckboxGroup(el, elForm) {
    var data = _utils["default"].buildElCheckboxGroup(el, elForm, confGlobal);
    var child = _utils["default"].buildElCheckboxGroupChild(el);
    if (child) child = "\n".concat(child, "\n"); // 换行
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " ").concat(data.size, " ").concat(data.border, " ").concat(data.min, " ").concat(data.max, " :disabled='").concat(data.disabled, "'>").concat(child, "</").concat(data.tag, ">");
  },
  'el-switch': function elSwitch(el, elForm) {
    var data = _utils["default"].buildElSwitch(el, elForm, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, "></").concat(data.tag, ">");
  },
  'el-slider': function elSlider(el, elForm) {
    var data = _utils["default"].buildElSlider(el, elForm, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " :disabled='").concat(data.disabled, "'></").concat(data.tag, ">");
  },
  'el-time-picker': function elTimePicker(el, elForm) {
    var data = _utils["default"].buildElTimePicker(el, elForm, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " ").concat(data.format, " :disabled='").concat(data.disabled, "'></").concat(data.tag, ">");
  },
  'el-date-picker': function elDatePicker(el, elForm) {
    var data = _utils["default"].buildElDatePicker(el, elForm, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " :disabled='").concat(data.disabled, "'></").concat(data.tag, ">");
  },
  'el-rate': function elRate(el, elForm) {
    var data = _utils["default"].buildElRate(el, elForm, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " ").concat(data.max, " ").concat(data['allow-half'], " ").concat(data['show-text'], " ").concat(data['show-score'], " :disabled='").concat(data.disabled, "'></").concat(data.tag, ">");
  },
  'el-color-picker': function elColorPicker(el, elForm) {
    var data = _utils["default"].buildElColorPicker(el, elForm, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.formModel, " ").concat(data.dynamic, " ").concat(data.size, " ").concat(data['show-alpha'], " ").concat(data['color-format'], " :disabled='").concat(data.disabled, "'></").concat(data.tag, ">");
  },
  'el-dropdown': function elDropdown(el, elForm) {
    var data = _utils["default"].buildElDropdown(el, elForm, confGlobal);
    var title = _utils["default"].buildDropdownTitle(el);
    var menu = _utils["default"].buildDropdownMenu(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.dynamic, " ").concat(data.arg, ">\n        ").concat(title, "\n        <el-dropdown-menu slot=\"dropdown\">\n        ").concat(menu, "\n        </el-dropdown-menu>\n        </").concat(data.tag, ">");
  },
  'yl-lc-data-census': function ylLcDataCensus(el) {
    var data = _utils["default"].buildYlDataCensus(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.title, " ").concat(data.titleFlag, " :source='").concat(data.vmodel, "'></").concat(data.tag, ">");
  },
  'el-calendar': function elCalendar(el) {
    var data = _utils["default"].buildElCalendar(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' v-model='").concat(data.vmodel, "'></").concat(data.tag, ">");
  },
  'yl-lc-upload': function ylLcUpload(el) {
    var data = _utils["default"].buildYlUpload(el, confGlobal);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.dynamic, " ").concat(data.numLimit, " :data='").concat(data.vmodel, "' :uploadFile='").concat(data.uploadFile, "' ").concat(data.byteLimit, " ").concat(data.limit, " ").concat(data.autoUpload, " ").concat(data.previewType, " ").concat(data.deleteBtn, " ").concat(data.disabled, "></").concat(data.tag, ">");
  },
  'yl-lc-echarts-line': function ylLcEchartsLine(el) {
    var data = _utils["default"].buildYlEcharLine(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' id=\"").concat(el.id, "\" height=\"").concat(el.height, "\" :chartData='").concat(data.vmodel, "'></").concat(data.tag, ">");
  },
  'yl-lc-echarts-pie': function ylLcEchartsPie(el) {
    var data = _utils["default"].buildYlEcharPie(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' id=\"").concat(el.id, "\" height=\"").concat(el.height, "\" :chartData='").concat(data.vmodel, "'></").concat(data.tag, ">");
  },
  'yl-lc-tree': function ylLcTree(el) {
    var data = _utils["default"].buildYlTree(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.treeData, " ").concat(data.dynamic, " ").concat(data['empty-text'], " ").concat(data['render-after-expand'], " ").concat(data['highlight-current'], " ").concat(data['default-expand-all'], " ").concat(data['expand-on-click-node'], " ").concat(data['check-on-click-node'], " ").concat(data['auto-expand-parent'], " ").concat(data['show-checkbox'], " ").concat(data.accordion, " ").concat(data.indent, " ").concat(data['icon-class'], "></").concat(data.tag, ">");
  },
  'yl-lc-icon': function ylLcIcon(el) {
    var data = _utils["default"].buildYlIcon(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' ").concat(data.dynamic, "></").concat(data.tag, ">");
  },
  'el-alert': function elAlert(el) {
    var data = _utils["default"].buildElAlert(el);
    return "<".concat(data.tag, " ref='").concat(data.ref, "' type=\"").concat(el.type, "\" title=\"").concat(el.title, "\" description=\"").concat(el.description, "\" close-text=\"").concat(el['close-text'], "\" ").concat(data.dynamic, " ").concat(data.style, "></").concat(data.tag, ">");
  }
};

/**
 * 组装html代码。【入口函数】
 * @param {String} type 生成类型，文件或弹窗等
 */
function makeUpHtml(componentList, type) {
  var htmlList = [];
  confGlobal = componentList;
  // 判断布局是否都沾满了24个栅格，以备后续简化代码结构
  //someSpanIsNot24 = componentList.some(item => item.__config__.span !== 24)
  // 遍历渲染每个组件成html
  componentList.forEach(function (el) {
    htmlList.push(layouts[el.__config__.layout](el));
  });
  var htmlStr = htmlList.join('\n');
  confGlobal = null;
  return htmlStr;
}